import type { OrderApiResponse } from 'src/libs/api/response/OrderApiResponse';
import { isBrowser } from 'src/libs/wa/utils/env';
import { getCookieNames } from 'src/utils/cookies';
import { pushDataLayerForAffiliatesOnePurchase } from 'src/utils/createDataLayerObject';

export const registerAffiliatesOneQueryParams = () => {
  if (!isBrowser()) return;

  const urlParams = new URLSearchParams(window.location.search);
  const utmMedium = urlParams.get('utm_medium');
  const utmSource = urlParams.get('utm_source');
  const vtmStatId = urlParams.get('vtm_stat_id');
  const isAccessWithMarge = urlParams.get('fpc');

  // Avoid double tracking if accessing from marge after accessing from affiliates one
  if (hasVisitedWithAffiliatesOneBefore() && !!isAccessWithMarge) {
    clearAffiliatesOneLocalStorage();
    return;
  }

  if (!isAffiliatesOne(utmMedium, utmSource, vtmStatId)) return;
  saveAffiliatesOneData(utmMedium, utmSource, vtmStatId);
};

export const isAffiliatesOne = (utmMedium: string | null, utmSource: string | null, vtmStatId: string | null) =>
  utmMedium === 'cpa' && utmSource === 'affiliates' && vtmStatId !== null;

const clearAffiliatesOneLocalStorage = () => removeLocalStorageItems(['utm_medium', 'utm_source', 'vtm_stat_id']);

const hasVisitedWithAffiliatesOneBefore = () => {
  const utmMedium = localStorage.getItem('utm_medium');
  const utmSource = localStorage.getItem('utm_source');
  const vtmStatId = localStorage.getItem('vtm_stat_id');
  return utmMedium === 'cpa' && utmSource === 'affiliates' && vtmStatId !== null;
};

const saveAffiliatesOneData = (utmMedium: string | null, utmSource: string | null, vtmStatId: string | null) => {
  if (utmMedium) localStorage.setItem('utm_medium', utmMedium);
  if (utmSource) localStorage.setItem('utm_source', utmSource);
  if (vtmStatId) localStorage.setItem('vtm_stat_id', vtmStatId);
};

export const handleAffiliatesOneConversion = (order: OrderApiResponse) => {
  // Cookieを取得
  const cookieNames = getCookieNames();
  // Margeでアクセスした履歴があるかどうかを確認
  const hasVisitedWithMarge = ['RCTG', 'RCTC', 'P_GCATS', 'P_CCATS', 'GCATS', 'CTG', 'CTC', 'CCATS'].some(
    (cookieName) => cookieNames.includes(cookieName)
  );
  // Margeでアクセスした履歴がある場合はreturn
  if (hasVisitedWithMarge) return;
  const utmMedium = localStorage.getItem('utm_medium');
  const utmSource = localStorage.getItem('utm_source');
  const vtmStatId = localStorage.getItem('vtm_stat_id');
  const isFromAffiliatesOne = utmMedium === 'cpa' && utmSource === 'affiliates' && vtmStatId;
  if (isFromAffiliatesOne) {
    const executedOrderIds = JSON.parse(localStorage.getItem('executedOrderIds') || '[]');
    if (executedOrderIds.includes(order.orderId)) return;
    pushDataLayerForAffiliatesOnePurchase(order);
    executedOrderIds.push(order.orderId);
    localStorage.setItem('executedOrderIds', JSON.stringify(executedOrderIds));
    clearAffiliatesOneLocalStorage();
  }
};
const removeLocalStorageItems = (keys: string[]) => {
  keys.forEach((key) => localStorage.removeItem(key));
};
